export const table = {
    th: {
        color: '#000',
        fontSize: 16,
        paddingLeft: 21
    },
    td: {
        fontSize: 14,
        height: 37,
        padding: '12px 20px 11px',
        whiteSpace: 'normal',
        verticalAlign: 'top'
    }
};


// WEBPACK FOOTER //
// src/lib/styles/table.js